import { render, staticRenderFns } from "./commonExam.vue?vue&type=template&id=6f06f7ae&scoped=true"
import script from "./commonExam.vue?vue&type=script&lang=js"
export * from "./commonExam.vue?vue&type=script&lang=js"
import style0 from "./commonExam.vue?vue&type=style&index=0&id=6f06f7ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06f7ae",
  null
  
)

export default component.exports